import type { QueryClient } from "@tanstack/react-query";
import { TooltipProvider } from "@lawline/ui/components/tooltip";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";

import { SessionTransitionProvider } from "@platform/auth/session-transition.context";

export interface RouterContext {
	queryClient: QueryClient;
}

function RootLayout() {
	return (
		<TooltipProvider delayDuration={700} disableHoverableContent>
			<SessionTransitionProvider>
				<Outlet />
			</SessionTransitionProvider>
		</TooltipProvider>
	);
}

// Parent of all feature routes. Features attach via getParentRoute: () => rootRoute.
export const rootRoute = createRootRouteWithContext<RouterContext>()({
	component: RootLayout,
});
